<div class="headline"
	 [ngClass]="{ active: (actualState$ | async)}"
	 (click)="next()">
	@if (actualState$ | async) {
		<div class="panel-trigger close"
			 title="{{'button.collapse.alt' | msgKeyCached}}">
			<mat-icon svgIcon="expand_less"></mat-icon>
		</div>
	} @else {
		<div class="panel-trigger open"
			 title="{{'button.expand.alt' | msgKeyCached}}">
			<mat-icon svgIcon="expand_more"></mat-icon>
		</div>
	}

	@if (name) {<span>{{name}}</span>}
	<ng-content select=".paneltitle"></ng-content>
</div>

<div class="content"
	 [@toggle]="animationState$  | async">
	<ng-content></ng-content>
</div>